/* JungleSocks · Performance — pestañas, puntos de tecnología y entrada al hacer scroll.
   CMC 22102026: las pestañas se manejan con teclado (flechas, Inicio, Fin), patrón ARIA tablist. */
(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-perf-tabs]').forEach(function (wrap) {
      if (wrap.dataset.perfReady) return;
      wrap.dataset.perfReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-perf-tab]'));
      var panels = wrap.querySelectorAll('[data-perf-panel]');
      var more = wrap.querySelector('[data-perf-more]');
      function select(i, focus) {
        tabs.forEach(function (t) {
          var on = t.dataset.perfTab === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) {
          var on = p.dataset.perfPanel === i;
          p.hidden = !on;
          if (on && more) {
            more.href = p.dataset.url;
            more.textContent = more.dataset.prefix + ' · ' + p.dataset.label + ' →';
          }
        });
      }
      tabs.forEach(function (t, idx) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { select(t.dataset.perfTab, false); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          e.preventDefault();
          select(next.dataset.perfTab, true);
        });
      });
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-perf-hotspots]').forEach(function (wrap) {
      if (wrap.dataset.perfReady) return;
      wrap.dataset.perfReady = '1';
      var targets = wrap.querySelectorAll('[data-perf-spot]');
      function pick(i) {
        targets.forEach(function (el) { el.setAttribute('aria-pressed', el.dataset.perfSpot === i ? 'true' : 'false'); });
      }
      targets.forEach(function (el) {
        ['click', 'mouseenter', 'focus'].forEach(function (ev) {
          el.addEventListener(ev, function () { pick(el.dataset.perfSpot); });
        });
      });
    });
  }

  function initReveal(root) {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.perf-reveal:not([data-perf-ready])').forEach(function (el) {
      el.dataset.perfReady = '1';
      var first = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (first) {
            first = false;
            if (e.isIntersecting) { io.disconnect(); } else { el.classList.add('is-hidden'); }
            return;
          }
          if (e.isIntersecting) { el.classList.remove('is-hidden'); io.disconnect(); }
        });
      }, { threshold: 0.06 });
      io.observe(el);
    });
  }

  function init(root) {
    initTabs(root);
    initHotspots(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
